import type { ReactNode } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import type { CardAppearance } from 'modules/shift_management/components/ShiftManagement/TimeGridTable/types'

interface Props {
  gridColumn: string
  gridRow: string
  minHeight: number
  paddingX: number
  cardPaddingX: number
  cardPaddingY: number
  radius: number
  appearance?: CardAppearance
  children: ReactNode
}

const GridCard = ({
  gridColumn,
  gridRow,
  minHeight,
  paddingX,
  cardPaddingX,
  cardPaddingY,
  radius,
  appearance,
  children,
}: Props) => {
  return (
    <Box
      background={appearance?.background}
      border={appearance?.border}
      className={appearance?.className}
      style={{
        opacity: appearance?.opacity,
        gridColumn,
        gridRow,
        alignSelf: appearance?.fillHeight ? 'stretch' : 'start',
        minHeight: `${String(minHeight)}px`,
        height: appearance?.fillHeight ? 'auto' : undefined,
        margin: `0 ${String(paddingX)}px`,
        padding: `${String(cardPaddingY)}px ${String(cardPaddingX)}px`,
        borderRadius: `${String(radius)}px`,
        boxSizing: 'border-box',
      }}
    >
      {children}
    </Box>
  )
}

export { GridCard }
